var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Logradouro","placeholder":"Logradouro","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.logradouro),callback:function ($$v) {_vm.logradouro=$$v},expression:"logradouro"}})}
var staticRenderFns = []

export { render, staticRenderFns }